
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 60 60"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M46.84 44.14V32.42c0-6.27-3.35-9.19-7.82-9.19a6.74 6.74 0 00-6.12 3.37v-2.89h-6.79c.09 1.92 0 20.43 0 20.43h6.79V32.73a4.63 4.63 0 01.22-1.65 3.71 3.71 0 013.48-2.48c2.46 0 3.44 1.87 3.44 4.62v10.92h6.79zM18.96 20.92a3.54 3.54 0 100-7.06 3.54 3.54 0 10-.09 7.06zm11 39.08a30 30 0 1130-30A30 30 0 0130 60zm-7.61-15.86V23.71h-6.78v20.43h6.79z"}})])
          )
        }
      }
    